import React, { useEffect } from 'react';

const GoogleAnalytics: React.FC = () => {
    useEffect(() => {
        // Check cookie consent before loading analytics
        const checkConsent = () => {
            const consent = localStorage.getItem('vanity_cookie_consent');
            if (consent) {
                try {
                    const parsed = JSON.parse(consent);
                    // Only load analytics if marketing cookies are accepted
                    if (parsed.marketing) {
                        loadGoogleAnalytics();
                    }
                } catch (e) {
                    console.error('Failed to parse cookie consent', e);
                }
            }
        };

        const loadGoogleAnalytics = () => {
            // Prevent loading multiple times
            if (window.dataLayer) return;

            // Load gtag.js script
            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://www.googletagmanager.com/gtag/js?id=G-53X68Q4LFN';
            document.head.appendChild(script);

            // Initialize dataLayer
            window.dataLayer = window.dataLayer || [];
            function gtag(...args: any[]) {
                window.dataLayer.push(args);
            }
            gtag('js', new Date());
            gtag('config', 'G-53X68Q4LFN');
        };

        checkConsent();

        // Listen for storage changes (when user updates cookie preferences)
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'vanity_cookie_consent') {
                checkConsent();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return null;
};

// Extend Window interface for TypeScript
declare global {
    interface Window {
        dataLayer: any[];
    }
}

export default GoogleAnalytics;
